import { Component } from '@angular/core';

@Component({
  selector: 'app-reportes-d',
  templateUrl: './reportes-d.component.html',
  styleUrls: ['./reportes-d.component.css']
})
export class ReportesDComponent {

}
